import React from "react"
import { GcmpProvider } from "google-cmp-addon"
import "./src/styles/main.scss"

export const wrapRootElement = ({ element }) => {
  const config = {
    debug: true,
    purposes: [
      {
        purpose: 10,
        selectors: '[data-name="analytics"],[data-consent="analytics"]',
        cookies: [/^ga/i, /^_ga/i, /^_gid/i],
      },
      {
        purpose: 7,
        selectors: '[data-name="externalmedia"],[data-consent="externalmedia"]',
      },
    ],
  }
  return <GcmpProvider config={config}>{element}</GcmpProvider>
}

export const onClientEntry = () => {
  fetch("/build.txt")
    .then(res => res.text())
    .then(buildId => {
      if (typeof window !== "undefined") {
        window.__BUILD_ID__ = buildId
      }
    })
}

export const onRouteUpdate = ({ location, prevLocation }) => {
  fetch("/build.txt")
    .then(res => res.text())
    .then(buildId => {
      if (
        typeof window !== "undefined" &&
        window.__BUILD_ID__ &&
        window.__BUILD_ID__ !== buildId
      ) {
        console.log(
          "New build detected on route update, reloading with cache-busting param..."
        )
        const url = new URL(window.location.href)
        url.searchParams.set("v", buildId)
        setTimeout(() => (window.location.href = url.toString()), 100)
      }
    })
}
